import axiosInstance from "../axiosInterceptor";

export async function getSubjectWiseSubSubject() {
  const response = await axiosInstance.get(`/admin/subSubject/getSubjectWiseSubSubject`);
  const data = response?.data;
  return data;
}
